import React, { Fragment } from "react";
import { FiImage } from "react-icons/fi";
import { FaSpinner } from "react-icons/fa";
import ErrorDialog from "../../notifications/errorDialog/ErrorDialog";
import { usePhotoPickerLogic } from "./usePhotoPicker";
import { useTranslation } from "react-i18next";

const PhotoPicker: React.FunctionComponent<{
    fileName: string;
    width: number;
    height: number;
    scale: number;
    ignoreSizeConstraints?: boolean;
    readonly?: boolean;
    onUpdated: (fileName: string) => void;
}> = (props) => {
    const {
        url,
        uploading,
        uploadErr,
        inputRef,
        onFileSelected,
    } = usePhotoPickerLogic(
        props.fileName,
        props.width,
        props.height,
        props.scale,
        props.onUpdated,
        props.ignoreSizeConstraints
    );

    const { t } = useTranslation();

    return (
        <Fragment>
            <ErrorDialog err={uploadErr}></ErrorDialog>
            <div>
                {t("upsells.reqDimensions", { width: props.width, height: props.height })}
            </div>
            <br />
            <div
                onClick={() => {
                    if (uploading) return null;
                    inputRef.current?.click();
                }}
                style={{
                    cursor: "pointer",
                    border: "solid 2px lightgray",
                    borderRadius: 7,
                    height: props.height * props.scale,
                    width: props.width * props.scale,
                    position: "relative",
                    backgroundImage: `${url.length === 0 ? "none" : `url(${url})`}`,
                    backgroundSize: "100% 100%",
                }}
            >
                <div
                    style={{
                        width: 40,
                        height: 40,
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: "auto",
                        marginBottom: "auto",
                    }}
                >
                    {uploading === false && url.length === 0 && <FiImage size={40}></FiImage>}
                    {uploading === true && <FaSpinner size={40}></FaSpinner>}
                </div>
            </div>
            <input
                style={{ visibility: "collapse" }}
                type="file"
                accept="image/*"
                ref={inputRef}
                onChange={(e) => {
                    const file = e.target?.files?.item(0);
                    if (file == null) return;
                    onFileSelected(file);
                }}
            />
        </Fragment>
    );
};

export default PhotoPicker;